import React, {useState} from "react";

import {View, Text, ScrollView, StyleSheet, TouchableOpacity, Image, Dimensions, TextInput} from "react-native";


import {RFValue} from "react-native-responsive-fontsize";
import {Entypo, FontAwesome6, Ionicons} from "@expo/vector-icons";
import Config from "../../Config";
import AntDesign from "@expo/vector-icons/AntDesign";
import AsyncStorage from "@react-native-async-storage/async-storage";
import axios from "axios";
import Toast from "../Components/Toast";
import Loading from "../Components/Loading";





const Tickets =({navigation})=>{
    const [messages, setMessages] = React.useState(['','']);

    let [data, setData] = useState(false);
    React.useEffect(() => {
        getData();
    },[]);
    let getData = async ()=>{
        try {
            let token = await AsyncStorage.getItem('token');
            let res = await axios.get(`${Config.api}/ticket/list`,{ 'headers': {  Authorization: 'Bearer '+token} });

            if(res.data.code != 1){
                // alert(JSON.stringify(res.data));
                // console.log(res.data.data);
                Toast(res.data.error);
            }
            setData( res.data);


        } catch (err) {
            console.log(err);
            alert('خطا')
        }
    }




    return (
        <View style={styles.container}>
            <View style={styles.header}>
                <TouchableOpacity onPress={()=>navigation.goBack()} style={{ flexDirection:'row', justifyContent:'flex-start', alignItems: 'center'}} >
                    <AntDesign name="arrowright" size={RFValue(22)} style={{marginLeft : 8}} color="white" />
                    <Text style={styles.title}>
                        پشتیبانی
                    </Text>
                </TouchableOpacity>
                <View style={{flex : 1}}></View>
                <TouchableOpacity onPress={()=>{navigation.navigate('SendTicket')}}  style={{ flexDirection:'row', justifyContent:'flex-start', alignItems: 'center'}}>

                    <Text style={styles.title2}>
                        ارسال پیام جدید
                    </Text>
                    <Entypo name="new-message"  size={RFValue(22)} style={{marginRight : 8}} color="#FFCC3E" />
                </TouchableOpacity>
            </View>


            {data ?
                <View style={styles.content}>
                    {data.tickets.length == 0 ?
                        <View style={{flex:1}}>
                            <View style={{flex : 1 , justifyContent:'center', alignItems: 'center',marginTop : -RFValue(80)}}>
                                <Image style={styles.sticker} source={{uri : `${Config.base}/images/sad.png`}}/>
                                <Text style={styles.nomsgtitle}>
                                    هنوز هیچ پیامی به ما ندادید!
                                </Text>
                                <Text style={styles.nomsgsubtext}>
                                    برای دریافت راهنمایی و پاسخ به سوالات خود، می‌توانید با تیم پشتیبانی همیورا در ارتباط باشید. ما اینجاییم تا به شما کمک کنیم.
                                </Text>
                            </View>

                            <TouchableOpacity onPress={()=>{
                                navigation.navigate('SendTicket',{
                                    phone: '123',
                                });
                            }} style={styles.button}>
                                <Text style={styles.buttonText}>نوشتن پیام  </Text>
                            </TouchableOpacity>
                        </View>
                        :
                        <ScrollView showsVerticalScrollIndicator={false}>
                            <View style={{flex:1}}>

                                {data.tickets.map( (item,index)=>
                                    <View key={index} style={styles.item}>
                                        <View style={{flexDirection:'row', justifyContent:'space-between', alignItems: 'center'}}>
                                            <Text style={styles.itemtitle}>{item.subject}</Text>
                                            <Text style={styles.date}>{item.jdate}</Text>
                                        </View>
                                        <Text style={styles.description}>
                                            {item.subject}
                                        </Text>
                                       <View style={{flexDirection:'row', justifyContent:'space-between', alignItems: 'center', width:'99%'}}>
                                           {item.unseen == 0 ?
                                               <Text style={styles.status}>
                                                   پاسخ داده شده
                                               </Text>
                                               :

                                               <Text style={styles.status2}>
                                                     در انتظار پاسخ
                                                </Text>
                                           }
                                           <TouchableOpacity onPress={()=>navigation.navigate('Chat',{id : item.id})} style={{flexDirection:'row', justifyContent:'flex-start', alignItems: 'center'}}>
                                               <Text style={styles.txtmore}>مشاهده جزئیات</Text>
                                               <AntDesign name="left" size={RFValue(20)} color="#FFCC3E" />
                                           </TouchableOpacity>
                                       </View>
                                    </View>
                                )}
                            </View>
                        </ScrollView>
                    }



                </View>
                :
                <Loading/>
            }





        </View>
    );
}

const styles = StyleSheet.create({

    txtmore : {
        color: '#FFCC3E',
        fontSize: RFValue(14),
        fontFamily : 'ykb',
    },
    description : {
        color: '#A6A6A6',
        fontSize: RFValue(14),
        fontFamily : 'yk',
        paddingVertical: RFValue(15),
        textAlign:'justify',
    },
    status : {
        color: '#33B300',
        fontSize: RFValue(14),
        fontFamily : 'yk',
        paddingVertical: RFValue(15),
        textAlign:'justify',
    },
    status2 : {
        color: '#D90000',
        fontSize: RFValue(14),
        fontFamily : 'yk',
        paddingVertical: RFValue(15),
        textAlign:'justify',
    },
    date : {
        color: '#A6A6A6',
        fontSize: RFValue(12),
        fontFamily : 'ykb',
    },

    itemtitle : {
      color: Config.maincolor,
        fontSize: RFValue(14),
        fontFamily : 'ykb',
    },

    item : {
        borderWidth: 1,
        borderRadius: RFValue(10),
        padding : RFValue(15),
        backgroundColor : "#FAFBFF",
        marginBottom : RFValue(15),
    },


    nomsgtitle : {
        fontSize: RFValue(17),
        fontFamily : 'ykb',
        color: Config.maincolor,


    },
    nomsgsubtext : {
        fontSize: RFValue(12),
        fontFamily : 'yk',
        color: Config.maincolor,
        paddingVertical: RFValue(14),
    },

    buttonText : {
        fontFamily : 'ykb',
        fontSize : RFValue(16),
        color : Config.maincolor,
    },
    button : {
        backgroundColor: Config.secondcolor,
        textAlign: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop : RFValue(35),
        borderRadius : RFValue(30),
        height : RFValue(40),

    },

    sticker  : {
      width: RFValue(60),
      height: RFValue(60),
        marginBottom : RFValue(20),
    },




    content : {
        flex: 1,
        paddingHorizontal: RFValue(20),
        justifyContent: "center",
        paddingVertical: RFValue(20),
        backgroundColor : 'white',
    },

    container : {
        flex: 1,
        backgroundColor: '#FFF',
    },
    header: {
        flexDirection : 'row',
        justifyContent : 'flex-start',
        alignItems : 'center',

        backgroundColor: '#000422',
        paddingHorizontal: RFValue(20),

        shadowColor:"#000000",
        shadowOffset: {
            width: 0,
            height: 50,
        },
        shadowOpacity: 1,
        shadowRadius: 0,
        elevation: 1
    },


    title : {
        fontSize: RFValue(17),
        fontFamily : 'ykb',
        color: '#FFF',
        paddingVertical: RFValue(14),

    },
    title2 : {
        fontSize: RFValue(14),
        fontFamily : 'ykb',
        color: '#FFCC3E',
        paddingVertical: RFValue(14),

    },

})


export default Tickets